import { css, keyframes } from "@emotion/react";
import styled from "@emotion/styled";

type Props = {
  busy?: boolean;
};
export const SkiliticsDots = ({ busy }: Props) => {
  return (
    <Indicators>
      {[1, 2, 3, 4].map((tag) => (
        <Indicator key={tag} $index={tag} $busy={busy} />
      ))}
    </Indicators>
  );
};

const waveAnimation = keyframes`
  0% { transform: scale(1); }
  25% { transform: scale(1); }
  50% { transform: scale(1.4); }
  75% { transform: scale(1); }
  100% { transform: scale(1); }
`;

const Indicator = styled.div<{ $busy?: boolean; $index: number }>`
  width: 12px;
  height: 12px;
  border-radius: 50%;

  animation: ${({ $busy, $index }) =>
    $busy
      ? css`
          ${waveAnimation} 1s ease-in infinite ${$index * 0.15}s
        `
      : "none"};

  background-color: ${({ $index, theme }) => {
    switch ($index) {
      case 1:
        return theme.primary;
      case 2:
        return theme.tertiary;
      case 3:
        return theme.warning;
      case 4:
        return theme.error;
      default:
        return "transparent";
    }
  }};
`;

const Indicators = styled.div`
  display: flex;
  justify-content: center;
  gap: 12px;
`;
